import { render, staticRenderFns } from "./RdmGenericEditRefactorCard.vue?vue&type=template&id=06362f34&scoped=true&"
import script from "./RdmGenericEditRefactorCard.vue?vue&type=script&lang=ts&"
export * from "./RdmGenericEditRefactorCard.vue?vue&type=script&lang=ts&"
import style0 from "./RdmGenericEditRefactorCard.vue?vue&type=style&index=0&id=06362f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06362f34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDivider})
